<div class="container">
  <div class="row mt-5">
    <div class="col-md-3 col-sm-6">
      <div
        class="card d-flex ustify-content-center font-weight-bold text-light border"
      >
        <div
          class="card"
          style="
            background-color: #2bae66ff;
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
              0 6px 20px 0 rgba(0, 0, 0, 0.19);
            background-size: cover;
          "
        >
          <ul class="list-group list-group-flush m-2 mt-1 text-dark">
            <li class="card list-group-item mb-3 mt-3 text-dark bg-light">
              <a
                [routerLink]="['/Complain-reg']"
                routerLinkActive="active"
                class="text-dark h7"
                ><i
                  class="fa fa-hand-o-right mr-3 text-danger"
                  aria-hidden="true"
                ></i
                >Complain Register</a
              >
            </li>
            <li class="card list-group-item mb-3 bg-light $zindex-modal:1060;">
              <a
                class="text-dark h7"
                [routerLink]="['/Complain-status']"
                routerLinkActive="active"
                ><i class="fa fa-hand-o-right mr-3 text-success"></i>Complain
                Status</a
              >
            </li>

            <li class="card list-group-item mb-3 bg-light">
              <i class="bi bi-star-fill fa-spin mr-3"></i>Online Apply
            </li>

            <li class="card list-group-item mb-3 bg-light">
              <i class="bi bi-star-fill fa-spin mr-3"></i>Online Apply
            </li>
            <li class="card list-group-item mb-3 bg-light">
              <i class="bi bi-star-fill mr-3"></i>Online Apply
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-sm-6">
      <h2 class="text-center">Notices & Events</h2>
      <ul class="shadow list-group d-flex">
        <!-- <li class="list-group-item"><h2>Recent</h2></li> -->

        <marquee behavior="scroll" direction="up" scrollamount="2">
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >event</i
              >Hon. Chief minister will inaugurate Kalinga Setu on 5/02/21 |
            </li></a
          >
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >notifications</i
              >25/5/2021 ରୁ 28/05/2021 ରେ ରଘନାଥପୁର ପଞ୍ଚାୟତରେ ଚାଉଳ ବଣ୍ଟନ |
            </li></a
          >
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >notifications</i
              >nrega ଫର୍ମ ପ୍ରୟୋଗ 5/02/21 ରେ ଆରମ୍ଭ ହେବ |
            </li></a
          >
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >notifications</i
              >25/5/2021 ରୁ 28/05/2021 ରେ ରଘନାଥପୁର ପଞ୍ଚାୟତରେ ଚାଉଳ ବଣ୍ଟନ |
            </li></a
          >
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >notifications</i
              >nrega ଫର୍ମ ପ୍ରୟୋଗ 5/02/21 ରେ ଆରମ୍ଭ ହେବ |
            </li></a
          >
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >notifications</i
              >25/5/2021 ରୁ 28/05/2021 ରେ ରଘନାଥପୁର ପଞ୍ଚାୟତରେ ଚାଉଳ ବଣ୍ଟନ |
            </li></a
          >
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >notifications</i
              >nrega ଫର୍ମ ପ୍ରୟୋଗ 5/02/21 ରେ ଆରମ୍ଭ ହେବ |
            </li></a
          >
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >notifications</i
              >25/5/2021 ରୁ 28/05/2021 ରେ ରଘନାଥପୁର ପଞ୍ଚାୟତରେ ଚାଉଳ ବଣ୍ଟନ |
            </li></a
          >
          <a
            ><li class="h6 list-group-item list-group-item">
              <i
                class="material-icons"
                style="
                  color: red;
                  display: inline-flex;
                  vertical-align: text-bottom;
                "
                >notifications</i
              >nrega ଫର୍ମ ପ୍ରୟୋଗ 5/02/21 ରେ ଆରମ୍ଭ ହେବ |
            </li></a
          >
        </marquee>
      </ul>
    </div>

    <div class="col-md-3 col-sm-12">
      <h2 class="text-center">Leadership</h2>
      <div class="shadow-lg p-2 card">
        <div class="card text-dark mb-2">
          <div class="card-header d-flex justify-content-center">
            <div class="avatar mx-auto">
              <img
                src="../../assets/photo6.jpg"
                class="rounded-circle z-depth-1 d-flex justify-content-center"
                style="width: 6rem"
                alt="Sample avatar"
              />
            </div>
          </div>
          <h2 class="card-title d-flex justify-content-center">
            Mrs. Gouri Naik
          </h2>
          <p class="card-text text-center">SARAPANCH</p>
        </div>

        <div class="card bg-light">
          <div class="card-header">
            <div class="avatar mx-auto d-flex justify-content-center">
              <img
                src="https://mdbootstrap.com/img/Photos/Avatars/img%20(9).jpg"
                class="rounded-circle z-depth-1"
                style="width: 6rem"
                alt="Sample avatar"
              />
            </div>
          </div>

          <h2 class="card-title d-flex justify-content-center">
            Mr. Sukumar Pani
          </h2>
          <p class="card-text text-center">PANCHAYAT EXECUTIVE OFFICER</p>
        </div>
      </div>
    </div>
  </div>
  <!-- < end about panchayat> -->
</div>

<!-- counter -->
<div class="container my-5">
  <!--Section: Content-->
  <section class="p-5 z-depth-1">
    <h2 class="text-center text-success font-weight-bold mb-5">
      Population Counter
    </h2>

    <div class="shadow row d-flex p-5 bg-light justify-content-center">
      <div class="col-md-6 col-lg-3 mb-4 text-center">
        <h4 class="h1 font-weight-normal mb-3">
          <i class="h1 bi bi-people text-success"></i>
          <span
            class="d-inline-block count-up"
            data-from="0"
            data-to="100"
            data-time="2000"
            >7,122</span
          >
        </h4>
        <p class="font-weight-normal text-muted">Population</p>
      </div>

      <div class="col-md-6 col-lg-3 mb-4 text-center">
        <h4 class="h1 font-weight-normal mb-3">
          <i class="h1 text-success fa fa-male" aria-hidden="true"></i>
          <span
            class="d-inline-block count2"
            data-from="0"
            data-to="330"
            data-time="2000"
            >3500</span
          >
        </h4>
        <p class="font-weight-normal text-muted">Men</p>
      </div>

      <div class="col-md-6 col-lg-3 mb-4 text-center">
        <h4 class="h1 font-weight-normal mb-3">
          <i class="h1 text-success fa fa-female" aria-hidden="true"></i>
          <span
            class="d-inline-block count3"
            data-from="0"
            data-to="430"
            data-time="2000"
            >3622</span
          >
        </h4>
        <p class="font-weight-normal text-muted">Women</p>
      </div>

      <div class="col-md-6 col-lg-3 mb-4 text-center">
        <h4 class="h1 font-weight-normal mb-3">
          <i class="h1 bi bi-building text-success"></i>
          <span
            class="d-inline-block count1"
            data-from="0"
            data-to="250"
            data-time="2000"
            >365</span
          >
        </h4>
        <p class="font-weight-normal text-muted">Houses</p>
      </div>
      <i
        class="h1 fa fa-chevron-circle-right text-success"
        aria-hidden="true"
      ></i>
    </div>
  </section>
  <!--Section: Content-->
</div>
<!-- end counter -->

<!-- < start Programmes & Schemes> -->
<div class="container pt-5 my-5">
  <!--Section: Content-->
  <section class="team-section text-center dark-grey-text">
    <!-- Section heading -->
    <h2 class="font-weight-bold pb-2 mb-4 text-success">
      Programmes & Schemes
    </h2>
    <!-- Section description -->
    <!-- <p class="text-muted w-responsive mx-auto mb-5">Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Fugit, error amet numquam iure provident voluptate esse quasi, veritatis totam voluptas nostrum quisquam
        eum porro a pariatur veniam.</p> -->

    <!-- Grid row -->

    <div class="row row-cols-1 row-cols-md-3 g-4">
      <div class="col">
        <div class="card shadow">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRX4ed8b7agQVUEUJSIAlndkkbexlydZL07mQ&usqp=CAU"
            class="card-img-top"
            alt="..."
          />
          <div class="card-body">
            <h2 class="card-title text-success">ବିଜୁ ପକ୍କା ଘର ଯୋଜନା</h2>
            <p class="card-text">details</p>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card shadow">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRX4ed8b7agQVUEUJSIAlndkkbexlydZL07mQ&usqp=CAU"
            class="card-img-top"
            alt="..."
          />
          <div class="card-body">
            <h2 class="card-title text-success">ମଧୁ ବାବୁ ପେନ୍ସନ୍ ଯୋଜନା</h2>
            <p class="card-text">details</p>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card shadow">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRX4ed8b7agQVUEUJSIAlndkkbexlydZL07mQ&usqp=CAU"
            class="card-img-top"
            alt="..."
          />
          <div class="card-body">
            <h2 class="card-title text-success">ମଧୁ ବାବୁ ପେନ୍ସନ୍ ଯୋଜନା</h2>
            <p class="card-text">details</p>
          </div>
        </div>
      </div>
    </div>

    <i
      class="h1 fa fa-chevron-circle-right text-success"
      aria-hidden="true"
    ></i>

    <!-- Grid row -->
  </section>
  <!--Section: Content-->
</div>

<!-- <end Programmes & Schemes> -->

<div class="container my-5 py-5 z-depth-1">
  <!--Grid row-->
  <div class="row d-flex justify-content-center mt-10">
    <!--Grid column-->
    <div class="col-md-6 text-center">
      <h2 class="font-weight-bold text-success">Gallery</h2>

      <!-- <p class="text-muted">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Id quam sapiente
      molestiae.</p> -->
    </div>
    <!--Grid column-->
  </div>
  <!--Grid row-->

  <div class="row">
    <div class="col-lg-4 col-md-12 mb-4 mb-lg-0">
      <img
        src="../../assets/WhatsApp Image 2025-09-10 at 10.25.28 PM.jpeg"
        class="w-100 shadow-1-strong rounded mb-4"
        alt=""
      />

      <img
        src="../../assets/WhatsApp Image 2025-09-10 at 10.25.34 PM.jpeg"
        class="w-100 shadow-1-strong rounded mb-4"
        alt=""
      />
    </div>

    <div class="col-lg-4 mb-4 mb-lg-0">
      <img
        src="../../assets/WhatsApp Image 2025-09-10 at 10.25.35 PM.jpeg"
        class="w-100 shadow-1-strong rounded mb-4"
        alt=""
      />

      <img
        src="../../assets/WhatsApp Image 2025-09-10 at 10.25.37 PM.jpeg"
        class="w-100 shadow-1-strong rounded mb-4"
        alt=""
      />
    </div>

    <div class="col-lg-4 mb-4 mb-lg-0">
      <img
        src="../../assets/WhatsApp Image 2025-09-10 at 10.25.43 PM (1).jpeg"
        class="w-100 shadow-1-strong rounded mb-4"
        alt=""
      />

      <img
        src="../../assets/WhatsApp Image 2025-09-10 at 10.25.44 PM.jpeg"
        class="w-100 shadow-1-strong rounded mb-4"
        alt=""
      />
    </div>
  </div>
  <button
    type="button"
    [routerLink]="['/Gallery']"
    routerLinkActive="active"
    class="btn btn-outline-success float-right"
  >
    more images
  </button>
</div>

<!-- Gallery -->

<div class="container my-5 py-5 z-depth-1">
  <!--Section: Content-->
  <section class="px-md-5 mx-md-5 text-center text-lg-left dark-grey-text">
    <style>
      .map-container {
        height: 230px;
        position: relative;
      }

      .map-container iframe {
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        position: absolute;
      }
    </style>

    <!--Grid row-->
    <div class="row d-flex justify-content-center">
      <!--Grid column-->
      <div class="col-md-6 text-center">
        <h2 class="font-weight-bold text-success">Contact Us</h2>

        <p class="text-muted">
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Id quam
          sapiente molestiae.
        </p>
      </div>
      <!--Grid column-->
    </div>
    <!--Grid row-->

    <!--Grid row-->
    <div class="row">
      <!--Grid column-->
      <div class="col-lg-6 col-md-12 mb-4 mb-md-0">
        <!-- Material outline input -->
        <div class="md-form md-outline mt-3">
          <input type="email" id="form-email" class="form-control" />
          <label for="form-email">E-mail</label>
        </div>

        <!-- Material outline input -->
        <div class="md-form md-outline">
          <input type="text" id="form-subject" class="form-control" />
          <label for="form-subject">Subject</label>
        </div>

        <!--Material textarea-->
        <div class="md-form md-outline mb-3">
          <textarea
            id="form-message"
            class="md-textarea form-control"
            rows="3"
          ></textarea>
          <label for="form-message">How we can help?</label>
        </div>

        <button type="submit" class="btn btn-success btn-sm ml-0">
          Submit<i class="far fa-paper-plane ml-2"></i>
        </button>
      </div>
      <!--Grid column-->

      <!--Grid column-->
      <div class="col-lg-6 col-md-12 mb-0 mb-md-0">
        <video width="520" height="270" controls>
          <source
            src="../../assets/videos/WhatsApp Video 2025-09-10 at 10.25.45 PM.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        <!--Google map-->
        <!-- <div id="map-container-google-1" class="z-depth-1 map-container mb-4">
          <iframe
            src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDD4T6QfZREyEe-69DsyyBRJTCjyiYdzUs&q=Ranipokhari+Mayurbhanj+Odisha+India&maptype=satellite&zoom=18"
            frameborder="0"
            style="border: 0"
            allowfullscreen
          ></iframe>
        </div> -->
        <!--Google Maps-->

        <p class="font-weight-bold">Raghunathpur, Odisha 758014</p>
      </div>
      <!--Grid column-->
    </div>
    <!--Grid row-->
  </section>
  <!--Section: Content-->
</div>
